import utils from '../utils/index'

import IdManager from '../IdManager/index'

import constants from '../constants/index'

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)

      this["LineHotAreaLayerMixin@handleClick"] = this["LineHotAreaLayerMixin@handleClick"].bind(this)

    }

    install() {
      super.install()

      this.svg.addEventListener("click", this["LineHotAreaLayerMixin@handleClick"], false)
    }

    destroy() {
      super.destroy()

      this.svg.removeEventListener("click", this["LineHotAreaLayerMixin@handleClick"], false)
    }

    ["LineHotAreaLayerMixin@handleClick"](e) {

      let hotarea = utils.closest(e.target, ".hotarea")
      if (hotarea) {
        let [_, lineId] = IdManager.split(hotarea.id)

        this.focusLine(this.lines[lineId])

      }

    }

    display() {
      let html = Object.keys(this.lines).map(lineId => {

        if (lineId === this.focusObjectId) {
          return ""
        }



        let line = this.lines[lineId]
          , { points } = line
        if (points.length < 2) {
          return ""
        }
        let { x, y } = points[points.length - 1]
          , { x: lx, y: ly } = points[points.length - 2]
          , deg

        if (Math.abs(lx - x) < 2) {
          deg = - 90 * (ly - y) / Math.abs(ly - y)
        } else {
          deg = Math.atan((ly - y) / (lx - x)) * 180 / Math.PI

          if (x < lx) {
            deg += 180
          }
        }

        return `
          <circle
            cx=${0}
            cy=${0}
            r=${10}

            fill=transparent
            fill-opacity=.3
            stroke=none
            class=hotarea 
            id=${IdManager.join(this.id, lineId, "hotarea")}
            transform="translate(${x}, ${y}) rotate(${deg}) translate(-8)"
          ></circle>          
        `
      }).join("")
      return super.display() + `<g>${html}</g>`
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/LineHotAreaLayerMixin.js